import React, { useState } from 'react'
import { editUserDetails, setTag } from '../../../Api Methods/Api';
import Input from '../../CustomDropDown/Input/Input';
import Button1 from '../../UI/Button/Button1';
import classes2 from "../../forms/InviteUserForm.module.css"
import DataManager from '../../../hooks/DataManager';
import { Button } from 'primereact/button';
import { useDispatch } from 'react-redux';

const UpdateUsername = ({ placeholder, successModal, errorModal, HandleCloseModal, HandleShowModal, userObject, setUserObject}) => {

    const dataManager = new DataManager();
    const token = localStorage.getItem('token');
    const client = localStorage.getItem('client');
    const apiData = {
        token,
        client,
    }
    const [username, setUsername] = useState(placeholder || "");
    const dispatch = useDispatch();
    const [showError, setShowError] = useState(false)

    const isValidName = (userName) => {
        if (userName && userName !== ""){
            return true
        }
        
        return false
    }

    const handleInputChange = (e) => {
        setUsername(e.target.value)
    }

    const HandleUpdateName = async () => {
        const body = {
            "userID": userObject.id,
            "columnName": "fullName",
            "newValue": username
        }

        if (isValidName(username)){
            const response = await editUserDetails(apiData, body, dispatch);
            if (response) {
                HandleCloseModal();
                successModal("Name successfully updated");

                setUserObject((prevUserObject) => ({
                    ...prevUserObject,
                    fullName: username
                }));

            } else {
                errorModal("Failed to update name, please try again")
            }
        } else {
            setShowError(true)
        }
    }

    return (
        <form method="dialog" >
            {showError && <p className={classes2.errorMessage}>Please enter a valid name</p>}
            <br></br>
            <Input
                type="text"
                value={username}
                onChange={(e) => handleInputChange(e)}
                placeholder={placeholder}
            />
            <br></br>
            <br></br>
            <Button icon="pi pi-save" onClick={HandleUpdateName} label="Save" severity='success'/>
        </form>
    )
}

export default UpdateUsername;